import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../common/button';
import { toast } from 'react-toastify';
import ToastMessage from '../common/ToastMessage';
import { useTranslation } from 'react-i18next';

const TermsAndPolicy = ({
  currentStep,
  nextStep,
  updateUser,
  termsContent,
  formData,
  updateSecurityQuestions,
}) => {
  const { t } = useTranslation();
  const ErrorMessage = ({ message }) => (
    <ToastMessage type="error" title="Registration" subTitle={message} />
  );
  const handleOnClick = async () => {
    console.log(
      'formData::::::::::::: Terms and Condition >>>>>> :::::::: ',
      formData,
    );
    updateSecurityQuestions()
      .then((res) => {
        updateUser()
          .then((res) => {
            nextStep();
          })
          .catch((error) => {
            toast.error(
              <ErrorMessage message={error?.response?.data?.message} />,
            );
          });
      })
      .catch((error) => {
        toast.error(<ErrorMessage message={error?.response?.data?.message} />);
      });
  };

  if (currentStep !== 6) {
    return null;
  }

  return (
    <div className="terms-and-policy">
      <Container className="mtop30 mt-4 custom-margin">
        <Row className="h-100">
          <Col lg={12} className="p-0">
            <div className="tab-container">
              <div id="content" className="mb-5">
                <div className="tab-content">
                  <div
                    className="privacy-content-wrapper px-1"
                    role="definition"
                  >
                    <h2>
                      {t(
                        'member.pages.registration.registration_info.terms_conditions',
                      )}
                    </h2>
                    <div>{termsContent}</div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="footer-container py-0">
          <Col md={12} lg={9} sm={12} xs={12} className="p-0 pl-md-3">
            <p className="privacy-disclaimer mb-3 mb-md-0">
              {t(
                'member.pages.registration.registration_info.terms_conditions_disclaimer_1',
              )}
            </p>
            <p className="privacy-disclaimer mb-3 mb-md-0">
              {t(
                'member.pages.registration.registration_info.terms_conditions_disclaimer_2',
              )}
            </p>
          </Col>
          <Col md={12} lg={3} sm={12} xs={12} className="p-0">
            <div className="text-right accept-button-container">
              <Button onClick={handleOnClick} className="float-right mr-0 mb-5">
                ACCEPT
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsAndPolicy;
